var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"sandbox":"allow-same-origin allow-scripts allow-top-navigation","scrolling":"no","width":"300","height":"400","frameBorder":"0","allowTransparency":"true","src":_vm.setSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }